import { useHttpClient } from '@/common/api/httpClient';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import type { CoilResponse } from './common/coilResponse';
import { useCoilStore } from 'shared/coils/stores/coilStore';
import type { StorageAreaResponse } from '@/storageAreas/api/models/storageAreaResponse';
import { useStorageAreaStore } from 'shared/storageAreas/stores/storageAreaStore';

export interface UpdateCoilRequest {
  coilId: string;
  coil: Coil;
}

export interface Coil {
  name?: string;
  diameter?: number;
  depth?: number|null;
  productId?: string;
  storageAreaId?: string;
  position?: number;
  level?: number;
}

export interface UpdateCoilResponse {
  coil: CoilResponse;
  previousStorageArea: StorageAreaResponse | null;
  storageArea: StorageAreaResponse | null;
}

export function useUpdateCoil() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const coilStore = useCoilStore();
  const storageAreaStore = useStorageAreaStore();

  return {
    execute
  };

  async function execute(action: UpdateCoilRequest) {
    const {
      coil: style,
      coilId: styleId
    } = action;

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`coil/${styleId}`), {
      method: 'PUT',
      headers,
      body: JSON.stringify(style)
    });

    const text = translations.value.coils.actions.update;

    const response = await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as UpdateCoilResponse;
        coilStore.add(json.coil);
        if (json.previousStorageArea) {
          storageAreaStore.add(json.previousStorageArea);
        }
        if (json.storageArea) {
          storageAreaStore.add(json.storageArea);
        }
        return {
          ok: true,
          coil: json.coil
        };
      },
    });

    return response;
  }
}


